import { Lightbulb, Undo, Popsicle, Camera, Pencil, RefreshCw, Clock, type LucideIcon } from "lucide-react";

export interface TipItem {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const NOTE_TIPS: TipItem[] = [
  {
    icon: Lightbulb,
    title: "Keep it light",
    description:
      "Quick, simple notes land best — think a friendly check-in or small reminder you care.",
  },
  {
    icon: Undo,
    title: "Call back to something they said",
    description:
      "Weekend plans, hobbies, small wins — anything that shows you're paying attention.",
  },
  {
    icon: Popsicle,
    title: "Stay casual & human",
    description:
      "Write like yourself. Teens respond best to warm, real, non-scripted messages.",
  },
];

export const MOMENT_TIPS: TipItem[] = [
  {
    icon: Lightbulb,
    title: "Add a little context",
    description:
      "A short caption or sentence helps teens understand why you shared the moment and invites them in.",
  },
  {
    icon: Camera,
    title: "Keep it personal, not perfect",
    description:
      "Teens don't need polished photos — candid snapshots from your day land better and feel more real.",
  },
  {
    icon: Pencil,
    title: "Share small moments, not big productions",
    description:
      "Your pet, a hobby, something you noticed on a walk — simple everyday things spark the best conversations.",
  },
];

export const SWAP_TIPS: TipItem[] = [
  {
    icon: Lightbulb,
    title: "Keep it light",
    description:
      "Swaps work best when they're fun and low-pressure.",
  },
  {
    icon: RefreshCw,
    title: "Share first",
    description:
      "When you share your photo first, it encourages your teen to participate.",
  },
  {
    icon: Clock,
    title: "Be patient",
    description:
      "Give your teen time to respond at their own pace.",
  },
];
